import { PricingDetails, PricingType } from "@dune/types";
import { privateAxios } from "../axios";
import { useQuery } from "@tanstack/react-query";
import { constructionSiteOfferPricingsQueryKeys } from "../query-keys/constructionSiteOfferPricings.query-keys";

export const getConstructionSiteOfferPricing = async (
	constructionSiteOfferId?: number,
	pricingType?: PricingType,
) => {
	const { data } = await privateAxios.get<PricingDetails | null>(
		`/construction-site-offer-pricings/offer/${constructionSiteOfferId}/${pricingType}`,
	);
	return data;
};

export const useGetConstructionSiteOfferPricing = (
	constructionSiteOfferId?: number,
	pricingType?: PricingType,
) => {
	return useQuery({
		queryKey: constructionSiteOfferPricingsQueryKeys.detail(
			constructionSiteOfferId,
			pricingType,
		),
		queryFn: () =>
			getConstructionSiteOfferPricing(constructionSiteOfferId, pricingType),
		enabled: !!constructionSiteOfferId && !!pricingType,
	});
};

export const getPricingByConstructionSiteAndBinderWarranty = async (
	constructionSiteId: number,
	binderWarrantyId: number,
	pricingType?: PricingType,
) => {
	const { data } = await privateAxios.get<PricingDetails | null>(
		`/construction-site-offer-pricings/pricing-by-construction-site-and-binder-warranty/${constructionSiteId}/${binderWarrantyId}/${pricingType}`,
	);
	return data;
};

export const useGetPricingByConstructionSiteAndBinderWarranty = (
	constructionSiteId: number,
	binderWarrantyId: number,
	pricingType?: PricingType,
) => {
	return useQuery({
		queryKey:
			constructionSiteOfferPricingsQueryKeys.detailByConstructionSiteAndBinderWarranty(
				constructionSiteId,
				binderWarrantyId,
				pricingType,
			),
		queryFn: () =>
			getPricingByConstructionSiteAndBinderWarranty(
				constructionSiteId,
				binderWarrantyId,
				pricingType,
			),
		enabled: !!constructionSiteId && !!binderWarrantyId && !!pricingType,
	});
};
